/** ProSorgu — çift katman stroke, filter yok */
import { QUERY_ICON_PRO } from './queryIconNeon.jsx';

function ProQueryPaths({ stroke, sw, swBold, accentW, accentStroke, strokeOpacity }) {
  const op = strokeOpacity != null ? { strokeOpacity } : {};
  return (
    <>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={swBold} {...op}>
        <rect x="92" y="100" width="278" height="188" rx="16" />
        <circle cx="342" cy="286" r="58" />
        <path d="M384 328 L444 388" />
        <path d="M418 362 L448 392" />
      </g>
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={sw} {...op}>
        <path d="M146 236 H318" />
        <path d="M204 288 V340" />
        <path d="M166 340 H276" />
        <path d="M142 230 V190" />
        <path d="M184 230 V168" />
        <path d="M226 230 V198" />
        <path d="M268 230 V148" />
        <path d="M310 230 V180" />
        <path d="M130 160 L172 134 L214 158 L258 122 L306 142 L342 110" />
        <circle cx="172" cy="134" r="9" />
        <circle cx="214" cy="158" r="9" />
        <circle cx="258" cy="122" r="9" />
        <circle cx="306" cy="142" r="9" />
        <circle cx="342" cy="286" r="35" />
      </g>
      <g stroke={accentStroke} strokeLinecap="round" strokeLinejoin="round" fill="none" strokeWidth={accentW} {...op}>
        <path d="M90 374 H144" />
        <path d="M292 374 H342" />
        <path d="M382 156 H430" />
        <path d="M400 206 H452" />
      </g>
    </>
  );
}

export function ProQueryIcon() {
  const c = QUERY_ICON_PRO;
  const sw = 30;
  const swBold = 38;
  const accentW = 12;
  const glowExtra = 8;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="none"
      aria-hidden="true"
      focusable="false"
      shapeRendering="geometricPrecision"
    >
      <ProQueryPaths
        stroke={c.glow}
        strokeOpacity={0.38}
        sw={sw + glowExtra}
        swBold={swBold + glowExtra}
        accentW={accentW + 4}
        accentStroke={c.glow}
      />
      <ProQueryPaths
        stroke={c.core}
        sw={sw}
        swBold={swBold}
        accentW={accentW}
        accentStroke={c.accent}
      />
    </svg>
  );
}
